import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const useApplyPreviewMutation = () => {
    return useMutation({
        mutationFn({ threadId, content }: { threadId: string; content: string }) {
            return salesApiService.aiAgent.email.applyEmailPreview({ threadId, content });
        },
    });
};

export default useApplyPreviewMutation;
